import { Component, OnInit } from '@angular/core';
import { companyInfo } from 'src/common';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {

  constructor() { }

  public companyInfo=companyInfo;

  ngOnInit(): void {
  }

}
